// extracted by mini-css-extract-plugin
export default {"container":"_3vYvqKa19QwwCzBPnS8H5f","contactImage":"_3IrVG0FejTI31bopdIlAXA","contactPerson":"_2ZwIvcq8oChzqexReg1LWx"};